import { Box, Text } from "@chakra-ui/layout";
import { Row, Col } from "antd";
import {
  PessoaDto,
  TipoUnidadePessoaEnum,
} from "features/unidades/typings/unidade";
import { TipoEntidadeEnum } from "resources/enums/conta";
import { Control, UseFormWatch } from "react-hook-form";
import Field from "components/Input/Field";
import SelectPessoas from "components/Input/SelectPessoas";
import SelectSexo from "components/Input/SelectSexo";
import SelectProfissao from "components/Input/SelectProfissao";
import SelectTipoVinculoPessoa from "components/Input/SelectTipoVinculoPessoa";
import { isValidCPF } from "@brazilian-utils/brazilian-utils";
import PrimaryButton from "components/Button/PrimaryButton";
import { AiOutlinePlus } from "react-icons/ai";
import colors from "resources/theme/colors";
import { useState, useRef, useEffect } from "react";
import ModalAddContato from "components/FormContatos/components/ModalAddContato";
import TabelaContato from "components/FormContatos/components/TabelaContato";
import UploadImagem from "components/Input/UploadImagem";
interface FormDadosPessoaProps {
  control: Control<PessoaDto, object>;
  watch: UseFormWatch<PessoaDto>;
  unidadeId: string;
  setLoadingUpload?: (loading: boolean) => void;
}

const tipoEntidades = [TipoEntidadeEnum.Condomino];

function FormDadosPessoa({
  control,
  watch,
  unidadeId,
  setLoadingUpload,
}: FormDadosPessoaProps) {
  const [indexEdit, setIndexEdit] = useState<number | undefined>();
  const tipoUnidadePessoaId = watch("tipoUnidadePessoaId");
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    if (Number.isInteger(indexEdit)) {
      setIsOpenModal(true);
    }
  }, [indexEdit]);

  const moradorExistente = watch("moradorExistente");

  return (
    <>
      <Box as={Row} mb={4} gutter={16} justifyContent="center">
        <Box as={Col} xs={6}>
          <Field
            control={control}
            name="imagemUrl"
            render={({ field }) => {
              return (
                <UploadImagem
                  {...field}
                  mode="camera"
                  onUploadChange={setLoadingUpload}
                  height="160px"
                />
              );
            }}
          />
        </Box>
      </Box>
      <Box as={Row} mb={4} gutter={16} ref={containerRef}>
        <Box as={Col} xs={14}>
          <Field
            label="Nome"
            control={control}
            name="nome"
            rules={{ required: "Campo obrigatório" }}
          />
        </Box>

        <Box as={Col} xs={10}>
          <Field
            shouldUnregister
            label="Email de login"
            control={control}
            name="email"
            rules={{
              required: {
                value: tipoUnidadePessoaId !== TipoUnidadePessoaEnum.Outros,
                message: "Informe o e-mail",
              },
            }}
          />
        </Box>
      </Box>

      {tipoUnidadePessoaId === TipoUnidadePessoaEnum.Outros ? (
        <Box as={Row} gutter={16} mb={4}>
          {moradorExistente ? (
            <Box as={Col} xs={8}>
              <Field
                shouldUnregister
                label="CPF"
                control={control}
                name="documento"
                rules={{
                  required: false,
                  validate: (v) => isValidCPF(v) || "CPF inválido",
                }}
                inputProps={{
                  type: "cpf",
                }}
              />
            </Box>
          ) : null}
          <Box as={Col} md={moradorExistente ? 8 : 12}>
            <Field
              shouldUnregister
              label="Vincular a uma pessoa"
              control={control}
              name="pessoaVinculadaId"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <SelectPessoas
                  {...field}
                  isInvalid={isInvalid}
                  tipoEntidades={tipoEntidades}
                  unidadeId={unidadeId}
                  incluirPessoasComUnidade
                />
              )}
            />
          </Box>

          <Box as={Col} md={moradorExistente ? 8 : 12}>
            <Field
              label="Tipo do Vínculo"
              control={control}
              shouldUnregister
              name="tipoVinculoPessoaId"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <SelectTipoVinculoPessoa isInvalid={isInvalid} {...field} />
              )}
            />
          </Box>
        </Box>
      ) : null}

      <Box as={Row} gutter={[16, 16]} mb={6}>
        {tipoUnidadePessoaId !== TipoUnidadePessoaEnum.Outros ? (
          <Box as={Col} xs={8}>
            <Field
              shouldUnregister
              label="CPF"
              control={control}
              name="documento"
              rules={{
                required: true,
                validate: (v) => isValidCPF(v) || "CPF inválido",
              }}
              inputProps={{
                type: "cpf",
              }}
            />
          </Box>
        ) : null}
        <Box as={Col} md={8}>
          <Field
            label="CNH"
            control={control}
            name="cnh"
            inputProps={{
              placeholder: "CNH",
            }}
          />
        </Box>
        <Box as={Col} md={8}>
          <Field
            label="Data de Nascimento"
            control={control}
            name="dataNascimento"
            inputProps={{
              type: "date",
            }}
          />
        </Box>
        <Box as={Col} md={8}>
          <Field
            label="Sexo"
            control={control}
            name="sexo"
            render={({ field }) => <SelectSexo {...field} />}
          />
        </Box>
      </Box>

      <Box>
        <Field
          name="contatos"
          control={control}
          render={({ field }) => (
            <>
              {isOpenModal ? (
                <ModalAddContato
                  isOpen={isOpenModal}
                  onClose={() => {
                    setIsOpenModal(false);
                    setIndexEdit(undefined);
                  }}
                  defaultData={
                    Number.isInteger(indexEdit)
                      ? field.value[indexEdit!]
                      : undefined
                  }
                  onSaved={(contato) => {
                    if (Number.isInteger(indexEdit)) {
                      const copy = [...field.value];

                      copy.splice(indexEdit!, 1, contato);

                      field.onChange(copy);
                    } else {
                      field.onChange([...field.value, contato]);
                    }
                    setIndexEdit(undefined);
                    setIsOpenModal(false);
                  }}
                />
              ) : null}
              <Box display={"flex"} alignItems="center">
                <Text color={"#8291A9"} fontWeight={"500"} fontStyle={"italic"}>
                  Contatos
                </Text>

                <PrimaryButton
                  style={{
                    minWidth: "21px",
                    height: "21px",
                    padding: 0,
                    background: "transparent",
                    color: `${colors.primary}`,
                    borderRadius: "50%",
                    border: `2px solid ${colors.primary}`,
                    marginLeft: "8px",
                  }}
                  onClick={() => setIsOpenModal(true)}
                >
                  <AiOutlinePlus />
                </PrimaryButton>
              </Box>
              <Box mt="8px">
                <TabelaContato
                  data={field.value ?? []}
                  isLoading={false}
                  containerRef={containerRef}
                  onDelete={(index) =>
                    field.onChange(
                      field.value.filter(
                        (_: any, _index: number) => _index !== index
                      )
                    )
                  }
                  onEdit={setIndexEdit}
                />
              </Box>
            </>
          )}
        />
      </Box>

      {tipoUnidadePessoaId !== TipoUnidadePessoaEnum.Outros ? (
        <Box as={Row} gutter={16} mb={6}>
          <Box as={Col} xs={12}>
            <Field label="RG" control={control} name="rg" shouldUnregister />
          </Box>

          <Box as={Col} xs={12}>
            <Field
              label="Profissão"
              control={control}
              name="profissaoId"
              shouldUnregister
              render={({ field }) => <SelectProfissao {...field} />}
            />
          </Box>
        </Box>
      ) : null}
    </>
  );
}

export default FormDadosPessoa;
